import {MoveTitleRankData, MoveResourceRankData} from '@/types';
import {RosterData} from '@/types/types';
import {PlanbordResource} from '@/types/api-object-extensions';

export class ResourceRosterRankUtil {
    public static getHighestResourceRank(roster: RosterData): number {
        return Math.max(0, ...roster.rosterResources.map((resource: PlanbordResource): number => resource.rankInRoster));
    }

    public static isMoveTitleRankData(rankData: MoveTitleRankData | MoveResourceRankData): rankData is MoveTitleRankData {
        return 'titleId' in rankData;
    }

    public static isMoveResourceRankData(rankData: MoveTitleRankData | MoveResourceRankData): rankData is MoveResourceRankData {
        return 'resourceId' in rankData;
    }
}
